import { createApiRef } from '@backstage/core-plugin-api';
import type {
  CreateOrUpdateEcsScheduledTaskRequest,
  EcsScheduledTaskDetail,
  EcsScheduledTaskSummary,
  EcsScheduledTasksAccount,
  LookupOption,
} from '@internal/plugin-ecs-scheduled-tasks-common';

export interface EcsScheduledTasksFrontendApi {
  listAccounts(): Promise<EcsScheduledTasksAccount[]>;

  listClusters(params: { accountId: string; region: string; provisionRoleArn?: string }): Promise<LookupOption[]>;
  listTaskFamilies(params: { accountId: string; region: string; provisionRoleArn?: string }): Promise<LookupOption[]>;
  listTaskRevisions(params: { accountId: string; region: string; family: string; provisionRoleArn?: string }): Promise<LookupOption[]>;
  getTaskDefinition(params: { accountId: string; region: string; taskDefinition: string; provisionRoleArn?: string }): Promise<any>;
  listSubnets(params: { accountId: string; region: string; provisionRoleArn?: string }): Promise<LookupOption[]>;
  listSecurityGroups(params: { accountId: string; region: string; provisionRoleArn?: string }): Promise<LookupOption[]>;

  listSchedules(params: { accountId: string; region: string; provisionRoleArn?: string; groupName?: string }, skipCache?: boolean): Promise<EcsScheduledTaskSummary[]>;

  invalidateCache(accountId: string, region: string, groupName?: string): void;
  clearCache(): void;
  getSchedule(params: { accountId: string; region: string; provisionRoleArn?: string; name: string; groupName?: string }): Promise<EcsScheduledTaskDetail>;

  createSchedule(
    payload: CreateOrUpdateEcsScheduledTaskRequest,
  ): Promise<EcsScheduledTaskDetail>;
  updateSchedule(
    name: string,
    payload: CreateOrUpdateEcsScheduledTaskRequest,
  ): Promise<EcsScheduledTaskDetail>;

  enableSchedule(params: {
    accountId: string;
    region: string;
    provisionRoleArn?: string;
    name: string;
    groupName?: string;
  }): Promise<void>;

  disableSchedule(params: {
    accountId: string;
    region: string;
    provisionRoleArn?: string;
    name: string;
    groupName?: string;
  }): Promise<void>;

  deleteSchedule(params: {
    accountId: string;
    region: string;
    provisionRoleArn?: string;
    name: string;
    groupName?: string;
  }): Promise<void>;
}

export const ecsScheduledTasksApiRef =
  createApiRef<EcsScheduledTasksFrontendApi>({
    id: 'plugin.ecs-scheduled-tasks.service',
  });
